import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { FunnelPage } from '../screens/admin/FunnelPage';
import { periodSearch } from '../screens/admin/period-search';

const searchSchema = z.object({
  ...periodSearch,
  /** Narrow to the companies one source and campaign brought (a bar on the Campaigns screen). */
  source: z.string().optional(),
  campaign: z.string().optional(),
  /** Narrow to one partner's companies: its code at sign-up, `none` for companies no partner sent, or `unlinked` for those a partner sent that have no partner link now. */
  partner: z
    .string()
    .regex(/^([A-Za-z2-9]{4}|none|unlinked)$/)
    .optional()
    .catch(undefined),
  /** The step whose companies the table shows. */
  step: z
    .enum(['signedUp', 'firstJob', 'setupFinished', 'firstPages', 'firstExport', 'paid'])
    .optional(),
  /** The step whose drop-offs the table shows: the companies that got that far and no further. */
  stopped: z
    .enum(['signedUp', 'firstJob', 'setupFinished', 'firstPages', 'firstExport', 'paid'])
    .optional()
    .catch(undefined),
});

export const Route = createFileRoute('/admin/funnel')({
  validateSearch: searchSchema,
  component: FunnelPage,
});
